export const DiscountTypes = [
    {id: 0, name:  "NORMAL"},
    {id: 2, name: "GIFT"},
];